import X from 'icons/indexed-icons/X';
import React from 'react';
import styled from 'styled-components';
import theme from 'themes';

type ChipProps = {
  files?: File[];
  handleRemove?: (file?: File) => void;
  margin?: string;
};

const Container = styled.div<{ margin?: string}>`
  display: flex;
  margin-top: 1rem;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin: ${({ margin }) => margin || undefined}
`;
export const ChipList = styled.div<{ width?: string }>`
  border: 1px solid ${theme.colors.primaryBlue5};
  border-radius: 2rem;
  width: ${({ width }) => width || '12rem'};
  white-space: nowrap;
  display: flex;
  align-items: center;
  padding: 8px 13px;
  gap: 8px;
  & svg {
    cursor: pointer;
  }
  .icon--x {
    height: 12px;
    path {
      stroke: ${theme.colors.textLightBlack};
      stroke-width: 1.75;
    }
  }
`;
export const ChipItem = styled.div<{ width?: string }>`
  width: ${({ width }) => width || '10rem'};
  overflow: hidden;
  font-size: 14px;
  line-height: 16px;
  text-overflow: ellipsis;
`;
export const DeleteIcon = styled.div`
  padding: 0 2px;
  display: flex;
`;

const ChipContainer = ({ files, handleRemove, margin }: ChipProps): JSX.Element => {
  return (
    <Container margin={margin}>
      {files?.map((file) => {
        return (
          <ChipList key={file.name}>
            <ChipItem>{file.name}</ChipItem>
            <DeleteIcon onClick={() => handleRemove && handleRemove(file)}>
              <X />
            </DeleteIcon>
          </ChipList>
        );
      })}
    </Container>
  );
};

export default ChipContainer;
